import {Injectable} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import {AuthorizationService} from './authorization.service';
import {LocalStorageService} from './local-storage.service';
import {TokenService} from './token.service';

@Injectable()
export class LocalizationService {

  constructor(private tokenService: TokenService, private authorizationService: AuthorizationService,
              private localStorageService: LocalStorageService, private route: ActivatedRoute) {}

  public getStartingLanguage(): Observable<string> {
    return this.route.queryParams.pipe(
      map(params => {
        const culture = params['culture'];
        const lang = params['lang'];
        const country = params['country'];
        let result = navigator.language;
        if (this.authorizationService.isUserLoggedIn()) {
          result = this.tokenService.getCulture();
        } else if (this.localStorageService.doesCultureExist()) {
          result = this.localStorageService.getCulture();
        }
        else if (culture){
          result = culture;
        }
        else if (lang) {
          result = `${lang.toLowerCase()}${country && country != '' && `-${country.toUpperCase()}`}`;
        }
        return result;
      })
    );
  }
}
